import { render, staticRenderFns } from "./CellRendererImageCustomer.vue?vue&type=template&id=5b4e69a1&scoped=true"
import script from "./CellRendererImageCustomer.vue?vue&type=script&lang=js"
export * from "./CellRendererImageCustomer.vue?vue&type=script&lang=js"
import style0 from "./CellRendererImageCustomer.vue?vue&type=style&index=0&id=5b4e69a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4e69a1",
  null
  
)

export default component.exports